import { makeAutoObservable } from "mobx";
import { CompanySettings } from "../app/modules/auth";

interface CompanyObject {
  name: string;
  name_en?: string;
  commercial_registration: string;
  entity_number: string;
  logo_url?: string;
  id?: string;
  refund_policy?: {
    en?: string;
    ar?: string;
  };
  vat_number?: string;
  settings?: CompanySettings;
  kyb_step_number?: number;
  sandbox?: boolean;
  created_at?: string;
}

class Company {
  name?: string;
  name_en?: string;
  commercial_registration?: string;
  entity_number?: string;
  logo_url?: string;
  id?: string;
  refund_policy?: {
    en?: string;
    ar?: string;
  };
  vat_number?: string;
  settings?: CompanySettings;
  kyb_step_number?: number;
  sandbox?: boolean;
  created_at?: string;

  constructor() {
    makeAutoObservable(this);
  }

  setCompany({
    name,
    commercial_registration,
    entity_number,
    logo_url,
    id,
    refund_policy,
    vat_number,
    settings,
    name_en,
    kyb_step_number,
    sandbox,
    created_at,
  }: CompanyObject): void {
    this.name = name;
    this.commercial_registration = commercial_registration;
    this.entity_number = entity_number;
    this.logo_url = logo_url;
    this.id = id;
    this.refund_policy = refund_policy;
    this.vat_number = vat_number;
    this.settings = settings;
    this.name_en = name_en;
    this.kyb_step_number = kyb_step_number;
    this.sandbox = sandbox;
    this.created_at = created_at;
  }

  setLogoUrl(logo_url: string): void {
    this.logo_url = logo_url;
  }

  setName(name?: string, name_en?: string): void {
    if (name !== undefined) this.name = name;
    if (name_en !== undefined) this.name_en = name_en;
  }

  setRefundPolicy(refund_policy: { en?: string; ar?: string }): void {
    this.refund_policy = refund_policy;
  }

  setVatNumber(vat_number: string): void {
    this.vat_number = vat_number;
  }

  updateSettings(newSettings: CompanySettings): void {
    this.settings = {
      ...this.settings, // Preserve existing settings
      ...newSettings, // Merge new settings
    };
  }
}

export default Company;
